import {useI18n} from '@yandex-delivery/core/i18n'
import type {Optional} from '@yandex-delivery/types'

import type {PickupPoint} from '../../../../../api/address/model/types'
import type {DestinationPointDeliveryMethod} from '../types'
import {SourcePointDeliveryMethod} from '../types'
import {isPostOffice} from '../utils/is-post-office'
import {isTerminal} from '../utils/is-terminal'
import {isWarehouse} from '../utils/is-warehouse'

export function usePointTitle(
  point: Optional<PickupPoint>,
  pointType: SourcePointDeliveryMethod.DropOffPoint | DestinationPointDeliveryMethod.PickUpPoint,
) {
  const i18n = useI18n()

  if (isPostOffice(point?._type)) {
    return point?.name
  }

  if (pointType === SourcePointDeliveryMethod.DropOffPoint && isWarehouse(point?._type)) {
    return i18n('ndd.dropoff_points.warehouse.label', 'Сортировочный центр')
  }

  if (isTerminal(point?._type)) {
    return i18n('ndd.pickup_points.terminal_type', 'Постамат')
  }

  if (pointType === SourcePointDeliveryMethod.DropOffPoint) {
    return i18n('ndd.pickup_points.dropoff_point_type', 'Пункт приёма')
  }

  return i18n('ndd.pickup_points.pickup_point_type', 'Пункт выдачи')
}
